export const INBOX = 'INBOX'
export const KB = 'KB'
export const ADDON = 'ADDON'

export const ALL = [INBOX, KB, ADDON]
